// EAIH W-24408262: canonicalize a user id (legacy UUID or the new
// coreOrgId+coreUserId composite) for case-insensitive compares. Lowercase
// ASCII [A-Z] only (not String.toLowerCase) so a non-ASCII char can't
// case-fold into a valid-looking id. Mirrors the server-side helper.
export const normalizeUserId = (id) =>
  typeof id === 'string'
    ? id.trim().replace(/[A-Z]/g, (c) => c.toLowerCase())
    : id;
